import styled from 'styled-components';
import Select from '@material-ui/core/Select';
import React from 'react';
import FormHelperText from '@material-ui/core/FormHelperText/FormHelperText';
import FormControl from '@material-ui/core/FormControl/FormControl';

const getRadialGradient = (from, to) =>
    `radial-gradient(100% 185.14% at 100% 100%, ${from} 0%, ${to} 100%)`;

export const FormControlWrapper = styled(FormControl)`
    & {
        max-width: 100%;
    }
`;

export const SelectWrapper = styled(({accentColor, ...otherProps}) => (
    <Select disableUnderline={true} {...otherProps} />
))`
    && {
        font: inherit;
        background: none;
        --switch: calc((var(80) - var(60)) * -100%);
        color: hsl(0, 0%, var(--switch));

        &.opened {
            .select-arrow {
                transform: rotate(0);
                transform: translate(0, 0);
                &:before {
                    transform: rotate(-45deg);
                }
                &:after {
                    transform: rotate(45deg);
                }
            }
        }

        &.Mui-disabled {
            background-color: unset;
        }

        .select-arrow {
            right: 6px;
            transform: rotate(0);
            width: 0;
            height: 6px;
            display: inline-block;
            position: relative;
            transition: 0.4s ease;

            &:before,
            &:after {
                position: absolute;
                content: '';
                display: inline-block;
                background-color: transparent;
                width: 3px;
                transform: rotate(0);
                border-bottom: 12px solid
                    ${({theme, accentColor}) => theme.palette.accent[accentColor]};
                top: -1px;
                transition: 0.4s ease;
                left: 0;
            }
            &:before {
                transform: rotate(-135deg);
            }
            &:after {
                transform: rotate(135deg);
                left: -7px;
            }
        }
    }
    &&.Mui-focused {
        background-color: unset;
    }
    &&:hover {
        background-color: unset;
    }
    &&::before {
        position: absolute;
        left: 0;
        bottom: 2px;
        content: '';
        width: 100%;
        height: 2px;
        background: ${(p) => p.theme.palette.accent[p.accentColor]};
        background: ${(p) =>
            getRadialGradient(
                p.theme.palette.gradient[p.accentColor].from,
                p.theme.palette.gradient[p.accentColor].to
            )};
    }
`;

export const FormHelperTextWrapper = styled(FormHelperText)`
    && {
        margin-top: 0;
        color: ${(p) => p.theme.palette.accent.bright.fire};
    }
`;
